import config from '@/../config/index.js'

// different url domain of corresponding environment server
const env = process.env.NODE_ENV === 'development'
  ? 'dev' : process.env.NODE_ENV === 'production'
    ? 'build' : 'test'

export const MESSAGE_TOP = 100
export const MESSAGE_DURATION = 3
export const COLLECT_MESSAGE_DURATION = 2000

export const A_MAP_Key = '436fe3a9d11ca834c1effc4524f5beea'

// 获取不同环境下不同的域名
export const API_ADDRESS = config[env].apiAddress
export const CACHE_ADDRESS = config[env].cacheAddress
export const MOB_ADDRESS = config[env].mobAddress
export const PC_ADDRESS = config[env].pcAddress

// wechat appid
export const WX_APP_ID = 'wx73d2d5862a2863b4'
export const WX_QR_URL = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
export const WX_GETTING_CODE_INTERVAL = 1000 // ms
export const WX_GETTING_CODE_TIMEOUT = 5 * 60 * 1000 // ms
export const CARD_NUMBER_REGULAR_EXPRESS = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/

export const FILE_TYPE = {
  'folder': require('@/assets/cloudstorage/icon-folder.png'),
  'doc': require('@/assets/cloudstorage/icon-docx.png'),
  'docx': require('@/assets/cloudstorage/icon-docx.png'),
  'xls': require('@/assets/cloudstorage/icon-xlsx.png'),
  'xlsx': require('@/assets/cloudstorage/icon-xlsx.png'),
  'ppt': require('@/assets/cloudstorage/icon-pptx.png'),
  'pptx': require('@/assets/cloudstorage/icon-pptx.png'),
  'pdf': require('@/assets/cloudstorage/icon-pdf.png'),
  'jpg': require('@/assets/cloudstorage/icon-image.png'),
  'jpeg': require('@/assets/cloudstorage/icon-image.png'),
  'png': require('@/assets/cloudstorage/icon-image.png'),
  'gif': require('@/assets/cloudstorage/icon-image.png'),
  'txt': require('@/assets/cloudstorage/icon-txt.png'),
  'mp4': require('@/assets/cloudstorage/icon-video.png'),
  'mov': require('@/assets/cloudstorage/icon-video.png')
}
export const OUTLETS_REASON_LIST = [
  {
    id: 0,
    label: '客户下错订单'
  },
  {
    id: 1,
    label: '客户地址/联系方式等填错，重新下单'
  },
  {
    id: 2,
    label: '客户需求有变动，不再需要了'
  },
  {
    id: 3,
    label: '客户的地址不在配送范围'
  }
]



// WEBPACK FOOTER //
// ./src/assets/data/constants.js